import React from "react";
import { Paper } from "@mui/material";
import TargetOrdersForm from "./TargetOrdersForm";
import TargetOrderBrokerMessageHeader from "./TargetOrderBrokerMessage";
import { useTargetState } from "src/store/features/TargetOrders.slice";
import TargetOrderSummery from "./TargetOrderSummery";

const TargetOrdersComponent = () => {
  const { viewSummery } = useTargetState();

  return (
    <Paper
      sx={{
        height: "753px",
        minWidth: "372px",
        borderRadius: "20px",
        boxShadow: " 0px 4px 20px rgba(173, 192, 203, 0.3)",
        flexShrink: 0,
      }}>
      {!viewSummery && <TargetOrderBrokerMessageHeader />}
      {!viewSummery && <TargetOrdersForm />}
      {viewSummery && <TargetOrderSummery />}
    </Paper>
  );
};

export default TargetOrdersComponent;
